// extracted by mini-css-extract-plugin
module.exports = {"card":"PasswordForget_card__2apam","logo":"PasswordForget_logo__3RyFT","form":"PasswordForget_form__2Wedq","error":"PasswordForget_error__1lyC1"};